<template>
    <div class="dn-progress-bar">
        <div class="row box-bar">
            <div class="col progress-label">
                <div class="block">
                    <b>{{ label }}</b>
                </div>
                <small v-if="!unlimited && unit">
                    {{ Math.ceil(used) }} / {{ Math.ceil(total) }}
                    {{ unit }}
                </small>
            </div>
            <div class="col progress-holder">
                <div class="overlabel">
                    <slot name="overlabel"></slot>
                </div>
                <div class="b-progress-bar-holder">
                    <b-progress v-if="unlimited" :value="1" :max="1" />
                    <template v-else>
                        <b-progress :value="Math.ceil(used / 1)" :max="Math.ceil(total)" />
                        <span>{{ Math.round((used / total) * 100) }}%</span>
                    </template>
                </div>
                <div class="reference">
                    <slot name="reference"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DnProgress-bar',
    props: {
        unit: {
            type: String
        },
        label: {
            type: String
        },
        used: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        },
        unlimited: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
@import '../../../../sass/utils/variables';

.dn-progress-bar {
    .b-progress-bar-holder {
        position: relative;
        width: 100%;

        span {
            position: absolute;
            right: 0;
            top: 0;
            font-size: 0.75em;
            color: white;
            font-weight: bold;
            font-size: 0.65em;
            width: 100%;
            text-align: center;
        }
    }

    .row {
        display: flex;
        flex-flow: row;
        grid: 1em;

        &.row-end {
            align-items: end;
            justify-content: end;
        }

        &.row-centered-v {
            align-items: center;
            justify-content: center;
        }

        &>.col {
            flex: 1;

            &.col-tight {
                flex: 0 1 3em;
            }
        }

        .progress-label {
            flex: 0 0 13em;
            line-height: 0.75em;
            text-align: right;

            b {
                display: inline-block;
            }
        }
    }

    .progress {
        min-width: 10em;

        &-holder {

            .overlabel {
                font-size: 0.8em;
                font-weight: bold;
                color: white;
            }

            .reference {
                font-size: 0.75em;
                color: $accent-dark;
                color: white;
            }
        }

        &-bar {
            // min-width: 10em;
            background-color: $accent;
            background: $gradPrimary;
        }
    }
}
</style>